var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationtypePlantsAndGarden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_10519_44050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 24.668C44 35.7137 27.017 51.3346 24 51.3346C20.983 51.3346 4 35.7137 4 24.668C4 13.6223 12.9543 4.66797 24 4.66797C35.0457 4.66797 44 13.6223 44 24.668Z",
    fill: "#D09386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 24C8 15.1634 15.1634 8 24 8C32.8366 8 40 15.1634 40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24Z",
    fill: "#F7D5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5354 17.2266C24.7865 16.9734 25.2086 16.9969 25.43 17.2764L25.4739 17.3408L25.7151 17.7451C26.1387 18.468 26.5228 19.2113 26.7083 19.9951C27.2228 19.4685 27.8945 19.0769 28.7014 18.7822C29.0447 18.6571 29.4163 18.8658 29.4925 19.2149L29.5032 19.2871L29.552 19.8994C29.6104 20.8883 29.5631 21.9564 29.1682 22.8828L30.9768 22.5918L31.1136 22.5801C31.7854 22.5752 32.2167 23.353 31.8011 23.9287L28.9641 27.8565C29.5891 28.2562 30.0042 28.955 30.0042 29.752C30.004 30.9945 28.9967 32.002 27.7542 32.002C26.7122 32.0018 25.8381 31.2925 25.5823 30.3311L20.5413 28.7969L19.9056 31.419C19.8076 31.8212 19.4017 32.0684 18.9993 31.9707C18.5973 31.8728 18.3503 31.4675 18.4475 31.0654L19.2503 27.7588L19.2317 25.6191L16.4495 24.4033L16.3811 24.3682C16.0503 24.1815 15.9075 23.7707 16.0628 23.415C16.2183 23.0594 16.617 22.8849 16.9788 23.001L17.0511 23.0283L20.0755 24.3516L21.4622 24.127C21.0335 23.8141 20.6789 23.4565 20.3997 23.0254C19.8282 22.1428 19.6193 21.0291 19.6067 19.5596C19.6034 19.156 19.9989 18.8519 20.3968 18.9863C21.3526 19.3098 22.246 19.7381 22.9153 20.3691C23.1201 19.2692 23.7217 18.2793 24.4847 17.2852L24.5354 17.2266ZM27.7542 29.002C27.3401 29.0021 27.0042 29.3378 27.0042 29.752C27.0043 30.166 27.3402 30.5018 27.7542 30.502C28.1683 30.502 28.504 30.166 28.5042 29.752C28.5042 29.3377 28.1684 29.002 27.7542 29.002ZM20.7327 25.7647L20.7454 27.291L25.7151 28.8037C26.0173 28.1547 26.6188 27.675 27.3431 27.541L29.6663 24.3232L20.7327 25.7647ZM20.6253 20.1377C20.684 21.2059 20.8829 21.9307 21.2395 22.4815C21.5967 23.033 22.147 23.4632 23.013 23.877H23.0149C23.1967 22.7808 22.9811 22.0225 22.5579 21.46C22.1408 20.9057 21.4789 20.483 20.6253 20.1377ZM24.9241 18.377C24.3384 19.2107 23.9676 19.9656 23.8675 20.751C23.7638 21.5649 23.943 22.4773 24.597 23.6162C25.586 22.4997 25.8651 21.5993 25.8206 20.7979C25.777 20.015 25.4269 19.2509 24.9241 18.377ZM28.5491 19.9277C27.8359 20.2608 27.3444 20.6784 27.0276 21.2041C26.7113 21.7292 26.5419 22.4079 26.5423 23.3066L27.8987 23.0879C28.5107 22.3038 28.6247 21.1781 28.5491 19.9277Z",
    fill: "#8F4838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_10519_44050",
    x: -2,
    y: -1,
    width: 52,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.152941 0 0 0 0 0.0862745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10519_44050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10519_44050",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.152941 0 0 0 0 0.0862745 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_10519_44050"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationtypePlantsAndGarden);
export default __webpack_public_path__ + "static/media/organizationtype-plants_and_garden.d1f168ea69b12bd92befed2e02ac0cf4.svg";
export { ForwardRef as ReactComponent };